import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setLanguage("nl")}
        className={`text-lg font-semibold px-3 py-2 h-auto hover:scale-110 transition-transform ${
          language === "nl" ? "ring-2 ring-primary" : "opacity-50"
        }`}
        title="Nederlands"
      >
        NL
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setLanguage("en")}
        className={`text-lg font-semibold px-3 py-2 h-auto hover:scale-110 transition-transform ${
          language === "en" ? "ring-2 ring-primary" : "opacity-50"
        }`}
        title="English"
      >
        EN
      </Button>
    </div>
  );
};

export default LanguageSwitcher;
